import { createAction } from "~/utils/actions";

export default {
	...createAction("EMPTY_LOG"),
};
